import React, { useState } from "react";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { FaEye } from "react-icons/fa";
import UsersPlan from "./UsersPlan";
import { useGetPaymentHistoryQuery } from "../../slices/admin/admin";
import { getUserInfo } from '../../utils/user.util';

const SubscriptionUser = () => {

  const localUser = getUserInfo();
  const userId = localUser?._id;
  
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  
  const offset = currentPage ;
  
  const { data: paymentData, isLoading, error } = useGetPaymentHistoryQuery({ 
    userId, 
    offset, 
    limit 
  });

 // console.log("Payment Data:", paymentData);

  const tableData = paymentData?.data || [];
  const totalCount = paymentData?.total || 0;
  const totalPages = Math.ceil(totalCount / limit);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

const getActivePlanData = () => {

  if (!tableData.length) return null;

  const today = new Date();
  today.setHours(0,0,0,0);

  const paidPlans = tableData.filter(item => item.status === "paid");

  if (!paidPlans.length) return null;

  const latestPlan = paidPlans[0];

  const expiryDate = new Date(latestPlan.planExpiredAt);
  expiryDate.setHours(0,0,0,0);

  // ❌ plan expired
  if (expiryDate < today) {
    return {
      activePlanId: null,
      showChoosePlan: true,
      daysRemaining: 0
    };
  }

  const daysRemaining = Math.ceil(
    (expiryDate - today) / (1000 * 60 * 60 * 24)
  );

  const showChoosePlan = daysRemaining <= 5;

  return {
    activePlanId: latestPlan.planId?._id,
    showChoosePlan,
    daysRemaining
  };

};
  const activePlanData = getActivePlanData();

  return (
    <div className={Styles.parent}>
      <div className={Styles.box}>

        <h1 className={Styles.heading}>My Subscription</h1>
        <UsersPlan activePlanId={activePlanData?.activePlanId} showChoosePlan={activePlanData?.showChoosePlan} />
        {/* ================= TABLE ================= */}
        <div className={Styles.tableWrapper}>
          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>Error loading payment history</p>
          ) : (
            <table className={Styles.table}>
              <thead>
                <tr>
                  {/* <th>Name</th>
                  <th>Mob Num</th> */}
                  <th>Plan Name</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Payment Date</th>
                  <th>Expiry Date</th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((item) => (
                  <tr key={item._id}>
                    {/* <td>{item.userId?.firstName} {item.userId?.lastName}</td>
                    <td>{item.userId?.phone}</td> */}
                    <td>{item.planId?.planName}</td>
                    <td>₹{item.amount}</td>
                    <td>
                      <span className={`${Styles.statusBadge} ${item.status === 'paid' ? Styles.statusPaid : Styles.statusFailed}`}>
                        {item.status}
                      </span>
                    </td>
                    <td>{formatDate(item.paymentDate || item.createdAt)}</td>
                    <td>{formatDate(item.planExpiredAt)}</td>
                  </tr>
                ))}
              </tbody>

            </table>
          )}
        </div>

        {/* ================= PAGINATION ================= */}
        <div className={Styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            value={limit}
            className={Styles.inputsbtn}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>

      </div>
    </div>
  );
};

export default SubscriptionUser;

